type QuickstartStepKey =
  | 'users_setup'
  | 'jobs_setup'
  | 'teammates_setup'
  | 'phone_number_setup'
  | 'recruiting_social_ads_setup'
  | 'scheduled_kickoff_call';

export type QuickstartStep = {
  key: QuickstartStepKey;
  title: string;
  description: string;
  buttonText: string;
  link: string;
  disabled: boolean;
  completed: boolean;
};

export const initialQuickstartSteps: QuickstartStep[] = [
  {
    key: 'users_setup',
    title: 'Invite your teammates',
    description:
      'Running a high performance team is hard. Invite your supporting teammates to help interview candidates, coach your agents, and facilitate a smooth onboarding process.',
    buttonText: 'Invite',
    link: '/settings/company/users?quickstart=true',
    disabled: false,
    completed: false,
  },
  {
    key: 'jobs_setup',
    title: 'Post your first job',
    description:
      'Post your first job to Humaniz so you can start interviewing candidates. We recommend posting at least 7 cities to get the most out of Humaniz.',
    link: '/jobs?sort=created&order=desc&status=Active&quickstart=true',
    buttonText: 'Post a job',
    disabled: false,
    completed: false,
  },
  {
    key: 'teammates_setup',
    title: 'Invite your agent roster',
    description:
      'Invite your agent roster to Humaniz so you can coach your agents with pipeline reviews and enroll them in the Humaniz Online Leads Accelerator.',
    link: '/team?status=Active&sort=created&order=desc&quickstart=true',
    buttonText: 'Invite',
    disabled: false,
    completed: false,
  },
  {
    key: 'phone_number_setup',
    title: 'Setup your Humaniz phone number',
    description: "You'll need a phone number to send and receive text messages to candidates and agents on your team.",
    link: '/quickstart/phone_number',
    buttonText: 'Setup',
    disabled: false,
    completed: false,
  },
  {
    key: 'recruiting_social_ads_setup',
    title: 'Setup social ads for recruiting',
    description: 'We use social ads to target experienced agents in your area.',
    link: '/quickstart/meta',
    buttonText: 'Start',
    disabled: false,
    completed: false,
  },
  {
    key: 'scheduled_kickoff_call',
    title: 'Schedule a kickoff call',
    description:
      'Have all of the above done? Schedule a kickoff call with our team so you can get the most out of Humaniz!',
    link: '/quickstart/schedule_kickoff_call',
    buttonText: 'Schedule',
    disabled: true,
    completed: false,
  },
];
